// This is the main application file which sets up routing and renders pages.
// It imports the Navbar component and the pages for Home, Trips, Budget and Planner.

import { React } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Navbar from "./components/navbar/Navbar";
import Home from "./pages/Home-page/Home";
import Trips from "./pages/NewTrip-page/NewTrip";
import Budget from "./pages/Budget-page/Budget";
import Planner from "./pages/ItineraryPlanner-page/Planner";
import SavedTrip from "./pages/SavedTrip-page/SavedTrip";
import EditTrip from "./pages/EditTrip-page/EditTrip";

import "./App.css";

function App() {


  return (
    <Router>
      <div className="app-wrapper">
      

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/trips" element={<Trips />} />
            <Route path="/budget" element={<Budget />} />
            <Route path="/planner" element={<Planner />} />
            <Route path="/planner/:trip_id" element={<Planner />} />
            <Route path="/saved-trip/:id" element={<SavedTrip />} />
            <Route path="/budget-saved/:trip_id" element={<Budget />} />
            <Route path="/edit-trip/:id" element={<EditTrip />} />

          </Routes>
        </div>
      </div>
    </Router>
  );
}
export default App;
